<app-fireworks [intensity]="fireworkIntensity" [label]="fireworkLabel"></app-fireworks>
<div class="modern-summary" [class.dark]="useDarkMode">
  <div class="modern-top-controls">
    <button class="modern-bigscreen-btn" type="button" id="modern-bigscreen"
      (click)="onOpenBigScreen()" aria-label="Open big screen dashboard">
      <span class="modern-bigscreen-icon"></span>
    </button>
    <tm1-tooltip anchor="modern-bigscreen" position="bottom">Big screen dashboard</tm1-tooltip>
    <div class="modern-theme-toggle">
      <span class="modern-theme-icon" aria-hidden="true">☀</span>
      <label class="modern-theme-switch">
        <input type="checkbox" [checked]="useDarkMode" (change)="onDarkModeToggle($event)"
          aria-label="Toggle dark mode" />
        <span class="modern-theme-track">
          <span class="modern-theme-thumb"></span>
        </span>
      </label>
      <span class="modern-theme-icon" aria-hidden="true">☾</span>
    </div>
  </div>
  <div class="modern-hero">
    <div class="modern-hero-card primary">
      <div class="modern-hero-header">
        <div class="modern-hero-label">
          <span>{{ fansInsidePrimary ? 'Fans Inside' : 'Entries' }}</span>
          <span class="modern-hero-date">
            <ng-container *ngIf="!dateRange">{{ formatHeroDate(date) }}{{ liveDate ? ' &middot; ' + liveDate : '' }}</ng-container>
            <ng-container *ngIf="dateRange">{{ formatHeroDate(date) }} &mdash; {{ formatHeroDate(endDate) }}</ng-container>
          </span>
        </div>
        <ng-container *ngIf="stopDataToggle || liveButton">
          <div class="live-control-row">
            <ng-container *ngIf="stopDataToggle">
              <span class="live-pill live"><span class="live-dot"></span>LIVE</span>
              <tm1-icon class="live-action" icon="pause" id="modernPause" (click)="pause.emit()"></tm1-icon>
              <tm1-tooltip anchor="modernPause" position="bottom">Pause live data refresh</tm1-tooltip>
            </ng-container>
            <ng-container *ngIf="liveButton">
              <span class="live-pill paused">PAUSED</span>
              <tm1-icon class="live-action" icon="play" id="modernPlay" (click)="play.emit()"></tm1-icon>
              <tm1-tooltip anchor="modernPlay" position="bottom">Resume live data refresh</tm1-tooltip>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="modern-hero-value">
        <app-rolling-counter
          [value]="(fansInsidePrimary ? attendanceSummary.inVenue : attendanceSummary.entries) || 0"></app-rolling-counter>
      </div>
      <div class="modern-hero-rate">
        <span class="rate-chip">
          <app-rolling-counter [value]="totalScanRate"></app-rolling-counter>
          <span class="rate-unit">scans / min</span>
        </span>
      </div>
      <div class="modern-hero-venue" *ngIf="venueName">
        {{ venueName }}
      </div>

      <div class="modern-hero-actions">
        <button class="modern-hero-action" type="button" id="modern-download"
          (click)="download.emit()" aria-label="Download Excel report">
          <span class="modern-hero-action-icon"
            style="-webkit-mask-image: url('../../../assets/download.svg'); mask-image: url('../../../assets/download.svg');"></span>
        </button>
        <tm1-tooltip anchor="modern-download" position="top">Download Excel report</tm1-tooltip>

        <button *ngIf="showShare" class="modern-hero-action" type="button" id="modern-share"
          (click)="share.emit()" aria-label="Share link">
          <span class="modern-hero-action-icon"
            style="-webkit-mask-image: url('../../../assets/share.svg'); mask-image: url('../../../assets/share.svg');"></span>
        </button>
        <tm1-tooltip *ngIf="showShare" anchor="modern-share" position="top">Copy share link</tm1-tooltip>

        <button *ngIf="showEmail" class="modern-hero-action" type="button" id="modern-email"
          (click)="email.emit()" aria-label="Email report">
          <span class="modern-hero-action-icon"
            style="-webkit-mask-image: url('../../../assets/email.svg'); mask-image: url('../../../assets/email.svg');"></span>
        </button>
        <tm1-tooltip *ngIf="showEmail" anchor="modern-email" position="top">Email report</tm1-tooltip>

        <button *ngIf="showSchedule" class="modern-hero-action" type="button" id="modern-schedule"
          (click)="schedule.emit()" aria-label="Schedule reports">
          <span class="modern-hero-action-icon"
            style="-webkit-mask-image: url('../../../assets/schedule.svg'); mask-image: url('../../../assets/schedule.svg');"></span>
        </button>
        <tm1-tooltip *ngIf="showSchedule" anchor="modern-schedule" position="top">Manage scheduled reports</tm1-tooltip>
      </div>
    </div>

    <div class="modern-stat modern-stat-pinnable" [class.is-pinned]="fansInsidePrimary">
      <button class="modern-stat-pin" type="button" id="modern-fans-inside-pin"
        (click)="toggleFansInsidePrimary()"
        [attr.aria-pressed]="fansInsidePrimary"
        aria-label="Show Fans Inside as the headline number">
        <span class="modern-stat-pin-icon"
          style="-webkit-mask-image: url('../../../assets/pin.svg'); mask-image: url('../../../assets/pin.svg');"></span>
      </button>
      <tm1-tooltip anchor="modern-fans-inside-pin" position="top">
        {{ fansInsidePrimary ? 'Show Entries as the headline number' : 'Show Fans Inside as the headline number' }}
      </tm1-tooltip>
      <div class="modern-stat-label">{{ fansInsidePrimary ? 'Entries' : 'Fans Inside' }}</div>
      <div class="modern-stat-value">
        <app-rolling-counter
          [value]="(fansInsidePrimary ? attendanceSummary.entries : attendanceSummary.inVenue) || 0"></app-rolling-counter>
      </div>
    </div>
    <div class="modern-stat">
      <div class="modern-stat-label">Exits</div>
      <div class="modern-stat-value">
        <app-rolling-counter [value]="attendanceSummary.exits || 0"></app-rolling-counter>
      </div>
    </div>
    <div class="modern-stat modern-stat-success" *ngIf="hasScanRate">
      <div class="modern-stat-label">Successful Scans</div>
      <div class="modern-stat-value">
        <app-rolling-counter [value]="totalSuccessRate" suffix="/min"></app-rolling-counter>
      </div>
    </div>
    <div class="modern-stat">
      <div class="modern-stat-label">Reentries</div>
      <div class="modern-stat-value">
        <app-rolling-counter [value]="attendanceSummary.reentries || 0"></app-rolling-counter>
      </div>
    </div>
    <div class="modern-stat">
      <div class="modern-stat-label">Internal</div>
      <div class="modern-stat-value">
        <app-rolling-counter [value]="attendanceSummary.internal || 0"></app-rolling-counter>
      </div>
    </div>
    <div class="modern-stat modern-stat-error" [class.has-errors]="totalErrorRate > 0"
      *ngIf="hasScanRate">
      <div class="modern-stat-label">Error Scans</div>
      <div class="modern-stat-value">
        <app-rolling-counter [value]="totalErrorRate" suffix="/min"></app-rolling-counter>
      </div>
    </div>
  </div>

  <ng-container *ngIf="topEntrancesByRate.length">
    <div class="modern-section-heading">
      <span>{{ hasScanRate ? 'Scan Rate by Entrance' : 'Fans Inside by Entrance' }}</span>

      <ng-container *ngIf="allowEntranceGrouping">
        <button class="modern-entrance-groups-btn" type="button" id="modern-entrance-groups"
          (click)="openEntranceGroups()" aria-label="Manage entrance groups">
          <span class="modern-entrance-groups-icon"
            style="-webkit-mask-image: url('../../../assets/cards.svg'); mask-image: url('../../../assets/cards.svg');"></span>
        </button>
        <tm1-tooltip anchor="modern-entrance-groups" position="top">Manage entrance groups</tm1-tooltip>

        <label class="modern-group-switch" *ngIf="hasEntranceGroups"
          appTooltip="Sum grouped entrances into single tiles">
          <input type="checkbox" [checked]="groupingOn" (change)="toggleGrouping()"
            aria-label="Group entrances" />
          <span class="modern-group-track"><span class="modern-group-thumb"></span></span>
          <span class="modern-group-label">Group</span>
        </label>
      </ng-container>

      <span class="modern-section-sub">{{ hasScanRate ? 'scans per minute' : 'fans inside' }}</span>
    </div>
    <div class="modern-rate-grid">
      <div class="modern-rate-tile" *ngFor="let ent of displayEntrances">
        <div class="modern-rate-tile-name">{{ ent.name }}</div>
        <ng-container *ngIf="hasScanRate; else entranceInsidePrimary">
          <div class="modern-rate-tile-value">
            <app-rolling-counter [value]="ent.scanRate"></app-rolling-counter>
            <span class="modern-rate-tile-unit">/min</span>
          </div>
          <div class="modern-rate-tile-meta">
            <app-rolling-counter [value]="ent.inVenue"></app-rolling-counter>
            <span class="modern-rate-tile-unit">inside</span>
          </div>
        </ng-container>
        <ng-template #entranceInsidePrimary>
          <div class="modern-rate-tile-value">
            <app-rolling-counter [value]="ent.inVenue"></app-rolling-counter>
            <span class="modern-rate-tile-unit">inside</span>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showErrorBreakdown && errorAggregates.length">
    <div class="modern-section-heading">
      <span>Errors by Result Code</span>
      <span class="modern-section-sub">{{ hasScanRate ? 'scans per minute' : 'total errors' }}</span>
    </div>
    <div class="modern-error-grid">
      <button class="modern-error-tile" type="button"
        *ngFor="let err of errorAggregates" (click)="openErrorDetail(err)"
        [attr.aria-label]="'Show events for ' + formatErrorCode(err.code)">
        <div class="modern-error-code">{{ formatErrorCode(err.code) }}</div>
        <div class="modern-error-rate" *ngIf="hasScanRate; else errorTotalPrimary">
          <app-rolling-counter [value]="err.rate" suffix="/min"></app-rolling-counter>
        </div>
        <ng-template #errorTotalPrimary>
          <div class="modern-error-rate">
            <app-rolling-counter [value]="err.total"></app-rolling-counter>
            <span class="modern-rate-tile-unit">total</span>
          </div>
        </ng-template>
        <div class="modern-error-meta">
          <ng-container *ngIf="hasScanRate">
            <app-rolling-counter [value]="err.total"></app-rolling-counter>
            <span>total &middot;</span>
          </ng-container>
          <app-rolling-counter [value]="err.percentOfEntries" [decimals]="2" suffix="%"></app-rolling-counter>
        </div>
        <div class="modern-error-events" *ngIf="err.events.length">
          {{ err.events.join(', ') }}
        </div>
      </button>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="selectedErrorAggregate">
  <div class="modal" (click)="closeErrorDetail()">
    <tm1-card class="modal-content error-detail-modal-content" (click)="$event.stopPropagation()">
      <span class="close" (click)="closeErrorDetail()">&times;</span>
      <h2 class="error-detail-title">{{ formatErrorCode(selectedErrorAggregate.code) }}</h2>
      <p class="error-detail-summary">
        <strong>{{ selectedErrorAggregate.total }}</strong> total
        &middot;
        <strong>{{ selectedErrorAggregate.rate }}</strong>/min
        &middot;
        <strong>{{ selectedErrorAggregate.percentOfEntries | number: '1.0-2' }}%</strong> of entries
      </p>
      <div class="schedule-table-wrapper error-detail-table-wrapper">
        <table class="schedule-table error-detail-table">
          <thead>
            <tr>
              <th>Event Code</th>
              <th>Event Name</th>
              <th class="num-col">Rate</th>
              <th class="num-col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let detail of selectedErrorAggregate.eventDetails">
              <td><strong>{{ detail.eventCode }}</strong></td>
              <td>{{ detail.name || '—' }}</td>
              <td class="num-col">{{ detail.rate }}/min</td>
              <td class="num-col">{{ detail.total }}</td>
            </tr>
            <tr *ngIf="!selectedErrorAggregate.eventDetails.length">
              <td colspan="4" class="error-detail-empty">No events recorded for this code.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </tm1-card>
  </div>
</ng-container>

<app-entrance-groups *ngIf="entranceGroupsModalOpen"
  [entranceNames]="allEntranceNames"
  [existingGroups]="entranceGroups"
  (save)="onEntranceGroupsSaved($event)"
  (cancel)="closeEntranceGroups()">
</app-entrance-groups>
